import { render, staticRenderFns } from "./Foot.vue?vue&type=template&id=78f77a77&scoped=true"
import script from "./Foot.vue?vue&type=script&lang=js"
export * from "./Foot.vue?vue&type=script&lang=js"
import style0 from "./Foot.vue?vue&type=style&index=0&id=78f77a77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f77a77",
  null
  
)

export default component.exports